export default __webpack_public_path__ + "static/media/11.ab814eb7.jpg";